import { every, some } from "lodash";
import { AsyncRequestStatus } from "./IAsyncWrapper.js";
const requestNotStarted = (status) => status === null || typeof status === "undefined" || status === AsyncRequestStatus.NotStarted;
const requestPending = (status) => status === AsyncRequestStatus.Pending;
const requestCompleted = (status) => status === AsyncRequestStatus.Completed;
const requestFailed = (status) => status === AsyncRequestStatus.Failed;
const requestStale = (status) => status === AsyncRequestStatus.Stale;
const requestPendingOrCompleted = (status) => requestPending(status) || requestCompleted(status);
const requestResolved = (status) => requestCompleted(status) || requestFailed(status) || requestStale(status);
const allRequestsNotStarted = (status = []) => Array.isArray(status) ? every(status, (s) => requestNotStarted(s)) : requestNotStarted(status);
const someRequestIsPending = (status = []) => Array.isArray(status) ? some(status, (s) => requestPending(s)) : requestPending(status);
const someRequestHasFailed = (status = []) => Array.isArray(status) ? some(status, (s) => requestFailed(s)) : requestFailed(status);
const allRequestsHaveResolved = (status = []) => Array.isArray(status) ? every(status, (s) => requestResolved(s)) : requestResolved(status);
const allRequestsHaveCompleted = (status = []) => Array.isArray(status) ? every(status, (s) => requestCompleted(s)) : requestCompleted(status);
const requestIsForbidden = (request) => {
  var _a;
  return request && request.status === AsyncRequestStatus.Failed && ((_a = request.errorContext) == null ? void 0 : _a.statusCode) === 403;
};
const getAsyncRequestStatus = (error) => !!error ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed;
const toSingleAsyncRequestStatus = (statuses) => {
  if (someRequestHasFailed(statuses)) {
    return AsyncRequestStatus.Failed;
  }
  if (someRequestIsPending(statuses)) {
    return AsyncRequestStatus.Pending;
  }
  if (allRequestsHaveCompleted(statuses)) {
    return AsyncRequestStatus.Completed;
  }
  return AsyncRequestStatus.NotStarted;
};
const getDefaultAsyncWrapperObj = () => {
  return {
    data: null,
    status: AsyncRequestStatus.NotStarted,
    error: ""
  };
};
const getCompletedAsyncWrapperObj = (data, error, errorContext) => {
  return {
    data,
    error,
    status: getAsyncRequestStatus(error),
    errorContext
  };
};
export {
  allRequestsHaveCompleted,
  allRequestsHaveResolved,
  allRequestsNotStarted,
  getAsyncRequestStatus,
  getCompletedAsyncWrapperObj,
  getDefaultAsyncWrapperObj,
  requestCompleted,
  requestFailed,
  requestIsForbidden,
  requestNotStarted,
  requestPending,
  requestPendingOrCompleted,
  requestResolved,
  requestStale,
  someRequestHasFailed,
  someRequestIsPending,
  toSingleAsyncRequestStatus
};
//# sourceMappingURL=IAsyncWrapper.utils.js.map
